export type HomeFolderBack = { href: string; selector: string };

const homeFolderBack = (
	folderTarget: { containerId: string } | null,
	parentHref: string,
	folderId: string,
): HomeFolderBack =>
	folderTarget
		? { href: "/", selector: `[data-group-key="${folderTarget.containerId}"] [data-folder="${folderId}"]` }
		: { href: parentHref, selector: `[data-folder="${folderId}"]` };

export default homeFolderBack;
